// @ts-nocheck
import cn from '@core/utils/classNames';

import styles from './DecisionFactorsFlags.module.css';
import decisionFactorsFlagsIcons from './DecisionFactorsFlagsDictionary';

export interface DecisionFactor {
  label: string;
}

interface DecisionFactors {
  value: DecisionFactor[];
}

interface DecisionFactorsFlagsProps {
  decisionFactors: DecisionFactors;
  asColumn?: boolean;
  showDescription?: boolean;
}

const DecisionFactorsFlags = ({
  decisionFactors,
  asColumn = false,
  showDescription = false,
}: DecisionFactorsFlagsProps) => {
  if (!decisionFactors?.value) {
    return null;
  }

  return (
    <div className={cn(styles.flagContent, asColumn && styles.asColumn, showDescription && styles.horizontal)}>
      {decisionFactors.value.map((flag, index) => {
        const factorKeys = Object.keys(decisionFactorsFlagsIcons);
        const matchedKey = factorKeys.find((key) => key && flag?.toLowerCase().includes(key?.toLowerCase()));
        const icon = matchedKey
          ? decisionFactorsFlagsIcons[matchedKey as keyof typeof decisionFactorsFlagsIcons]?.icon
          : decisionFactorsFlagsIcons.default.icon;
        const description = matchedKey
          ? decisionFactorsFlagsIcons[matchedKey as keyof typeof decisionFactorsFlagsIcons]?.description
          : decisionFactorsFlagsIcons.default;
        return (
          <div className={cn(styles.flag, showDescription ? styles.showDescription : '')} key={flag?.label}>
            <div className={styles.flagHeader}>
              <span className={styles.icon}>{icon}</span>
              <span className={styles.title}>{flag}</span>
            </div>
            {showDescription && <p className={styles.description}>{description}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default DecisionFactorsFlags;
